import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Facebook, Instagram, Twitter, Youtube, Video, Film } from "lucide-react";

const Footer = () => {
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("Inscrição realizada com sucesso!");
    const form = e.target as HTMLFormElement;
    form.reset();
  };

  return (
    <footer className="bg-background border-t border-border py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-8">
          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <div className="flex items-center mb-4">
              <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center mr-2">
                <span className="text-primary-foreground font-bold">S</span>
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                Sussurros da Meia-Noite
              </span>
            </div>
            <p className="text-muted-foreground mb-4 max-w-md">
              Plataforma para criação de conteúdo usando ferramentas de IA como ChatGPT, Deep AI, Clideo e muito mais.
            </p>
            <form onSubmit={handleSubscribe} className="flex gap-2">
              <Input 
                type="email" 
                placeholder="Seu email" 
                className="max-w-xs" 
                required 
              />
              <Button type="submit" variant="outline" className="border-primary hover:bg-primary/10">
                Inscrever
              </Button>
            </form>
          </div>
          
          <div>
            <h3 className="text-foreground font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-muted-foreground hover:text-foreground transition-colors">Home</a>
              </li>
              <li>
                <a href="/melhores-sites-completo" className="text-muted-foreground hover:text-foreground transition-colors">Melhores Sites Completo</a>
              </li>
              <li>
                <a href="/sites-usados" className="text-muted-foreground hover:text-foreground transition-colors">Sites Usados</a>
              </li>
              <li>
                <a href="/videos-usados" className="text-muted-foreground hover:text-foreground transition-colors">Vídeos Usados</a>
              </li>
              <li>
                <a href="/jogos" className="text-muted-foreground hover:text-foreground transition-colors">Sites de Jogos</a>
              </li>
              <li>
                <a href="/series-japonesas" className="text-muted-foreground hover:text-foreground transition-colors">Séries Japonesas</a>
              </li>
              <li>
                <a href="/megazone-downloads" className="text-muted-foreground hover:text-foreground transition-colors">Megazone Downloads</a>
              </li>
              <li>
                <a href="/hotmart" className="text-muted-foreground hover:text-foreground transition-colors">Produtos Hotmart</a>
              </li>
              <li>
                <a href="/encurtador" className="text-muted-foreground hover:text-foreground transition-colors">Encurta.net</a>
              </li>
              <li>
                <a href="/musicful" className="text-muted-foreground hover:text-foreground transition-colors">Musicful AI</a>
              </li>
              <li>
                <a href="/nota-fiscal-paulista" className="text-muted-foreground hover:text-foreground transition-colors">Nota Fiscal Paulista</a>
              </li>
              <li>
                <a href="/radio-online" className="text-muted-foreground hover:text-foreground transition-colors">Rádio Online</a>
              </li>
              <li>
                <a href="/lipsync-tutorial" className="text-muted-foreground hover:text-foreground transition-colors">LipSync Tutorial</a>
              </li>
              <li>
                <a href="/translate" className="text-muted-foreground hover:text-foreground transition-colors">Tradutor</a>
              </li>
              <li>
                <a href="/design-tools" className="text-muted-foreground hover:text-foreground transition-colors">Ferramentas de Design</a>
              </li>
              <li>
                <a href="#tools" className="text-muted-foreground hover:text-foreground transition-colors">Ferramentas</a>
              </li>
              <li>
                <a href="#create" className="text-muted-foreground hover:text-foreground transition-colors">Como Criar</a>
              </li>
              <li>
                <a href="#gallery" className="text-muted-foreground hover:text-foreground transition-colors">Galeria</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-7689103" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Sussurros da Meia Noite</a>
              </li>
              <li>
                <a href="https://megazonedownloads.comunidades.net/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Megazone Downloads (Site Original)</a>
              </li>
              <li>
                <a href="https://www.bitchute.com/accounts/referral/killer45/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Criar Conta Bitchute</a>
              </li>
              <li>
                <a href="https://www.tiktok.com/@gameover2661" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">TikTok</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UC-20RsfqftBP6yKfOUHEdsA" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Canal YouTube</a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCYfW1FfL2OZk5u9-GakVKJg" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">CraftyCreations</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Planeta Terra Chamando</a>
              </li>
              <li>
                <a href="/crafty-creations" className="text-muted-foreground hover:text-foreground transition-colors">Vídeos de Animais</a>
              </li>
              <li>
                <a href="/planeta-terra-chamando" className="text-muted-foreground hover:text-foreground transition-colors">Documentários de Natureza</a>
              </li>
              <li>
                <a href="https://www.youtube.com/live/B1CdO1-2asA" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Live Completa</a>
              </li>
              <li>
                <a href="https://encurta.net/ref/killer56" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Encurta.net</a>
              </li>
              <li>
                <a href="https://www.instagram.com/luzdivina909/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Instagram Luz Divina</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-foreground font-semibold mb-4">Ferramentas</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://chat.openai.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">ChatGPT</a>
              </li>
              <li>
                <a href="https://deepai.org" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Deep AI</a>
              </li>
              <li>
                <a href="https://clideo.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Clideo</a>
              </li>
              <li>
                <a href="https://www.capcut.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">CapCut</a>
              </li>
              <li>
                <a href="https://rumble.com/register/FARIAS/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Rumble</a>
              </li>
              <li>
                <a href="https://old.bitchute.com/channel/jGs5mLAXFlSu/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Bitchute</a>
              </li>
              <li>
                <a href="https://www.clipto.com/pt/media-downloader/youtube-downloader" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Clipto Downloader</a>
              </li>
              <li>
                <a href="https://livrariagokage.blogspot.com/2025/04/100-contos-de-terror.html" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">100 Contos de Terror</a>
              </li>
              <li>
                <a href="https://livrariagokage.blogspot.com/2025/04/poder-sem-limites.html" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Poder Sem Limites</a>
              </li>
              <li>
                <a href="https://www.oneimagevideo.com/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">One Image Video</a>
              </li>
              <li>
                <a href="https://vispunk.com/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Vispunk</a>
              </li>
              <li>
                <a href="https://leonardo.ai/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Leonardo AI</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UC-20RsfqftBP6yKfOUHEdsA" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">YouTube Studio</a>
              </li>
              <li>
                <a href="https://www.youtube.com/live/B1CdO1-2asA" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">YouTube Live</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-foreground font-semibold mb-4">Bitcoin & Faucets</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://viefaucet.com/?r=64bb4dd7db722a8f70680e39" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">VieFaucet</a>
              </li>
              <li>
                <a href="https://www.koiniom.com/affiliate/qsoRq56Qzd" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Koiniom</a>
              </li>
              <li>
                <a href="https://payeer.com/05327110" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Payeer</a>
              </li>
              <li>
                <a href="https://faucetpay.io/?r=6547" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">FaucetPay</a>
              </li>
              <li>
                <a href="https://freebitco.in/?r=1641466" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">FreeBitcoin</a>
              </li>
              <li>
                <a href="https://rumble.com/v3vbh3w-freebitcoin-aposta-3.mp4.html" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">FreeBitcoin Tutorial</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-foreground font-semibold mb-4">Meus Sites</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://br.pinterest.com/crisgride/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Pinterest</a>
              </li>
              <li>
                <a href="https://gokagen.comunidades.net/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Gokagen Comunidades</a>
              </li>
              <li>
                <a href="https://livrariagokage.blogspot.com/2025/03/meus-canal-no-youtube.html" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Livraria Gokage</a>
              </li>
              <li>
                <a href="https://gokagen.blogspot.com/2025/04/meus-canal-no-site-rumble.html" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Gokagen Blog - Canais Rumble</a>
              </li>
              <li>
                <a href="https://www.bandlab.com/hulkstaranger/likes/posts" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">BandLab</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-foreground font-semibold mb-4">Meus Canais no YouTube</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Planeta Selvagem 2</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCVvCouJz1bgUvppoKywZY3w" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Mundo da Música</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UC3OZQzlF-lDaXIxXpfjwKYQ" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Hulk Star (Loterias)</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCGajLCMSud7T3P0Qvtee8bw" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Desenhos Animados da TV</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCekE2SMNXqQDZWq5dpzDq6A" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Rock Gametrons (Games)</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCZ0020Iw2UmKGhn_HUDb92w" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Futebok</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCjRjVRJpkKHIrtnBPFS2bfQ" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Trens e Trilhos</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Sonic Sprount</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCWBdZHo3T2Aq67G6rDcOefg" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Espurna Catalana (Faísca Catalã)</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCUutP5m1-8eIVZzdd6YT2LQ" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Nightmare Chronicles (Filmes)</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UC3YCfgCRUp9TFKLW9ju7D6w" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">YouTube Shortcute</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCOyRktVk5KWVaDf6GqwFbNg" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">King Jedvaldo564</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCppyKd4HpINjrhIyGi9u-dA" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Goodstar Ranger</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UC-20RsfqftBP6yKfOUHEdsA" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Tropa do Humor</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCYfW1FfL2OZk5u9-GakVKJg" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">CraftyCreations</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UCZkTECrSp6P-a_c6srDh18A" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">SnapShots</a>
              </li>
              <li>
                <a href="https://studio.youtube.com/channel/UC11Xp100hABKDEtYOYDxJrg" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Mix Musical</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-foreground font-semibold mb-4">Meus Canais no Rumble</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://rumble.com/register/FARIAS/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Registrar no Rumble</a>
              </li>
              <li>
                <a href="https://rumble.com/c/Rockdragon" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Rockdragon</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-656703" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Mestre do Jogo do Bicho</a>
              </li>
              <li>
                <a href="https://rumble.com/c/gameTrindade" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Game Trindade</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-678967" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Freebitcoin Ultimate</a>
              </li>
              <li>
                <a href="https://rumble.com/c/planetaselvagem6" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Planeta Selvagem 6</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-707703" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Filmes Luma</a>
              </li>
              <li>
                <a href="https://rumble.com/c/tiktokezeiro" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Tiktozeiro</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-1223953" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Ganhe Dinheiro</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-1285082" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Striderman</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-1313413" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Musicsom2356</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-1368031" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Gameover Shorts</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-1599626" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Neobux</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-1632222" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Futebok</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-2501890" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Contos</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-3001464" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Canal de Oração</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-3010402" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Desenhos Animados da TV</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-4943695" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Music Music Mosaic</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-7684699" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Megazone Downloads</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-7689103" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Sussurros da Meia Noite</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-1164751" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Loja Rangerstar</a>
              </li>
              <li>
                <a href="https://rumble.com/c/c-1194461" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">Loja NFTs</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center">
          <p className="text-muted-foreground text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Sussurros da Meia-Noite. Todos os direitos reservados.
          </p>
          
          <div className="flex flex-wrap gap-4">
            <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
              <Facebook size={20} />
            </a>
            <a href="https://www.instagram.com/luzdivina909/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
              <Instagram size={20} />
            </a>
            <a href="https://br.pinterest.com/crisgride/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors font-bold">
              Pinterest
            </a>
            <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
              <Twitter size={20} />
            </a>
            <a href="https://studio.youtube.com/channel/UC-20RsfqftBP6yKfOUHEdsA" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
              <Youtube size={20} />
            </a>
            <a href="https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Planeta Selvagem 2">
              <Youtube size={20} />
            </a>
            <a href="https://studio.youtube.com/channel/UCVvCouJz1bgUvppoKywZY3w" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Mundo da Música">
              <Youtube size={20} />
            </a>
            <a href="https://studio.youtube.com/channel/UC3OZQzlF-lDaXIxXpfjwKYQ" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Hulk Star (Loterias)">
              <Youtube size={20} />
            </a>
            <a href="https://studio.youtube.com/channel/UC3YCfgCRUp9TFKLW9ju7D6w" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="YouTube Shortcute">
              <Youtube size={20} />
            </a>
            <a href="https://studio.youtube.com/channel/UCOyRktVk5KWVaDf6GqwFbNg" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="King Jedvaldo564">
              <Youtube size={20} />
            </a>
            <a href="https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Sonic Sprount">
              <Youtube size={20} />
            </a>
            <a href="https://old.bitchute.com/channel/jGs5mLAXFlSu/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
              <Video size={20} />
            </a>
            <a href="https://www.tiktok.com/@gameover2661" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors font-bold">
              TikTok
            </a>
            <a href="https://gokagen.comunidades.net/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors font-bold">
              Gokagen
            </a>
            <a href="https://www.bandlab.com/hulkstaranger/likes/posts" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors font-bold">
              BandLab
            </a>
            <a href="https://rumble.com/c/c-7689103" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors">
              <Film size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;